(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["country-popup"] && !Shopify.designMode) return;
  try {
    
  class CountryPopup extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.debug = false; // ponytail: flip to true to enable debug logs
      this.pill = this.querySelector('.country-pill');
      this.pillLabelEl = this.querySelector('[data-pill-label]');
      this.dialog = document.getElementById(`country-popup-modal-${this.sectionId}`);
      this.form = this.dialog?.querySelector('[data-country-form]');
      this.marketsNode = document.getElementById(`country-popup-markets-${this.sectionId}`);
      this.markets = JSON.parse(this.marketsNode?.textContent || '[]');
      this.storageKey = 'theme:country-popup:dismissed';
      this.dismissDays = 7;
    }

    log(...args) {
      if (this.debug) console.log('[country-popup]', ...args);
    }

    connectedCallback() {
      this.log('connected', {
        sectionId: this.sectionId,
        hidden: this.hasAttribute('hidden'),
        pageType: this.dataset.pageType,
        dismissed: this.dismissInfo(),
        marketsCount: this.markets.length,
      });
      if (this.hasAttribute('hidden')) return;
      if (this.isDismissed()) return;

      this.fetchAndShow();

      this.form?.addEventListener('submit', (e) => this.onSubmit(e));

      // Dismiss only on explicit user intent — mirroring the triggers of
      // ModalDialog.hide() (global.js). Never on script-triggered attribute
      // churn; the dialog lives on <body> amid app scripts.
      this.dialog?.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.dismiss(); // backdrop click
      });
      this.dialog
        ?.querySelector('[id^="ModalClose-"]')
        ?.addEventListener('click', () => this.dismiss());
      this.dialog?.addEventListener('keyup', (e) => {
        if (e.code.toUpperCase() === 'ESCAPE') this.dismiss();
      });
    }

    dismissInfo() {
      try {
        const until = parseInt(localStorage.getItem(this.storageKey) || '0', 10);
        const remaining = until - Date.now();
        return { until, remainingMs: remaining, suppressed: remaining > 0 };
      } catch (e) {
        return { error: String(e) };
      }
    }

    isDismissed() {
      try {
        const until = parseInt(localStorage.getItem(this.storageKey) || '0', 10);
        return until && Date.now() < until;
      } catch (e) {
        return false;
      }
    }

    dismiss() {
      try {
        localStorage.setItem(
          this.storageKey,
          String(Date.now() + this.dismissDays * 864e5)
        );
      } catch (e) {}
      if (this.pill) this.pill.hidden = true;
    }

    async fetchAndShow() {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const exclude = window.Shopify?.country || '';
        const url =
          `${root}browsing_context_suggestions.json?country[enabled]=true`
          + `&country[exclude]=${encodeURIComponent(exclude)}`;
        this.log('fetching', { url, exclude });

        const res = await fetch(url, { credentials: 'same-origin' });
        this.log('response', { status: res.status, ok: res.ok });

        if (!res.ok) return;
        const data = await res.json();
        this.log('payload', {
          hasDetectedValues: !!data?.detected_values,
          hasDetectedCountry: !!data?.detected_values?.country,
          suggestionsCount: data?.suggestions?.length ?? 0,
        });

        const detected =
          data?.detected_values?.country
          || data?.suggestions?.[0]?.parts?.country;
        this.log('detected', detected);

        if (!detected) return;

        this.log('markets configured',
          this.markets.map((m) => ({
            country: m.country,
            url: m.url,
          })));

        const market = this.markets.find((m) => m.country === detected.handle);
        this.log('matched market', market);

        if (!market) return;
        if (market.showPill === false) return;

        if (market.url) {
          try {
            const targetHost = new URL(market.url).host;
            const sameHost = window.location.host === targetHost;
            this.log('same-host check', {
              currentHost: window.location.host,
              targetHost,
              skip: sameHost,
            });
            if (sameHost) return;
          } catch (e) {
            this.log('bad url', market.url);
          }
        }

        this.render(detected, market);
        this.log('rendered — pill should be visible', {
          pillHidden: this.pill.hidden,
        });
        this.pill.hidden = false;
      } catch (e) {
        console.warn('[country-popup] error', e);
      }
    }

    render(country, market) {
      this.pillLabelEl.textContent = this.tpl(
        market.pillLabel || 'Visiting from {country}?',
        country
      );
    }

    tpl(str, country) {
      return str.replace('{country}', country.name || country.handle);
    }

    onSubmit(e) {
      const select = this.form?.querySelector('select[name="country_code"]');
      const market = this.markets.find((m) => m.country === select?.value && m.url);
      this.dismiss(); // selecting a value ends the feature either way
      if (!market) return; // no external URL configured — localization form posts normally

      e.preventDefault();
      window.open(this.withScaRef(market.url), '_blank', 'noopener');
      this.dialog?.hide();
    }

    // Carry the UpPromote affiliate ref to the other store: URL param wins,
    // else rebuild from what the tracking script stored (scaaf_aid + scaaf_hc).
    // ponytail: if the hash half is missing we skip — a partial ref misattributes.
    withScaRef(url) {
      try {
        const aid = localStorage.getItem('scaaf_aid');
        const hc = localStorage.getItem('scaaf_hc');
        const ref =
          new URLSearchParams(window.location.search).get('sca_ref')
          || (aid && hc ? `${aid}.${hc}` : null);
        if (!ref) return url;
        const u = new URL(url, window.location.href);
        u.searchParams.set('sca_ref', ref);
        return u.href;
      } catch (e) {
        return url;
      }
    }
  }

  if (!customElements.get('country-popup')) {
    customElements.define('country-popup', CountryPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
